import React from 'react';
import { Link } from 'react-router-dom';
import ComparisonTable from '../components/ComparisonTable';

const TheCompetition = () => {
  return (
    <section className="section-wrapper bg-white px-6 py-12 md:px-20 text-deep-navy">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-primary mb-6">
          The Competition: You vs. Them
        </h2>

        <p className="text-lg leading-relaxed text-gray-800 mb-6">
          Tier 1 retailers have access to tools, capital, and expert teams that
          small business owners could never afford on their own. But here's the
          truth: they're not just competing with you — they're outmaneuvering
          you with data, automation, and scale.
        </p>
        <p className="text-lg leading-relaxed text-gray-800 mb-12">
          At BetterTurns, we believe it’s time to level the playing field. This
          side-by-side comparison exposes how retail giants operate — and how
          the co-op model gives you a fighting chance.
        </p>

        <ComparisonTable />

        <div className="text-center mt-8">
          <p className="text-gray-700 text-base">
            Curious how Tier 1 retailers build teams and systems like this?
            <Link
              to="/resources"
              className="text-primary font-semibold hover:underline ml-2"
            >
              Explore our retail strategy resources →
            </Link>
          </p>
        </div>

        {/* Section Divider */}
        <div className="text-center my-16">
          <h3 className="text-xl font-semibold text-deep-navy uppercase tracking-wide">
            In Summary
          </h3>
        </div>

        {/* Final 2-Column Summary Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Column: Big Box */}
          <div className="bg-soft-sky p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold text-deep-navy mb-4">
              Big-Box Retailers
            </h3>
            <ul className="space-y-3 text-gray-700 list-disc list-inside">
              <li>Full-time buyers, planners, and pricing teams</li>
              <li>Real-time sales analytics and planogram optimization</li>
              <li>Volume discounts from national vendors</li>
              <li>Proprietary ERP and predictive pricing engines</li>
              <li>Co-opting shelf space with slotting fees</li>
              <li>Centralized control over inventory and replenishment</li>
            </ul>
          </div>

          {/* Column: Independent Store Owners */}
          <div className="bg-white p-6 rounded-lg shadow border border-cool-gray">
            <h3 className="text-xl font-semibold text-deep-navy mb-4">
              Independent Store Owners
            </h3>
            <ul className="space-y-3 text-gray-700 list-disc list-inside">
              <li>Juggling buying, selling, and operations daily</li>
              <li>Little to no access to real-time analytics</li>
              <li>Limited pricing leverage with vendors</li>
              <li>Manual or outdated POS systems</li>
              <li>No planogram tools or space management data</li>
              <li>Inventory decisions based on intuition, not insight</li>
            </ul>
          </div>
        </div>

        {/* Closing CTA */}
        <div className="mt-14 text-center">
          <h4 className="text-2xl font-bold text-rosewood mb-4">
            Better Turns is your secret weapon.
          </h4>
          <p className="text-gray-700 text-lg mb-6">
            Through shared analytics, co-op strength, and modern tools, we’re
            closing the gap—together.
          </p>
          <Link
            to="/join"
            className="inline-block bg-primary text-white px-6 py-3 rounded-lg shadow hover:bg-primary-dark transition"
          >
            Join the Movement
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TheCompetition;
